<template>
    <div>
        <Button :disabled="!infoShift.id" :loading="!infoShift.id" @click="CloseShiftDialog()" label="Đóng ca" icon="pi pi-lock" severity="danger" size="small" raised></Button>
        <Dialog v-model:visible="CloseShiftModal" position="top" :draggable="false" modal header="Đóng ca bán hàng" :style="{ width: '80%' }">
            <div class="flex flex-column gap-3">
                <div class="flex gap-8">
                    <label for=""
                        >Giờ mở ca: <strong>{{ format(infoShift.startShiftAt, 'dd/MM/yyyy HH:mm') }}</strong></label
                    >
                    <label for=""
                        >Nhân viên: <strong>{{ infoShift.userName }}</strong></label
                    >
                </div>
                <div class="card mb-0 border-primary px-3 py-3">
                    <div class="flex justify-content-between align-items-center">
                        <span class="font-semibold">Đầu ca</span>
                        <span class="text-primary font-semibold">Tiền mặt: {{ formatPrice(infoShift.startAmount) }}</span>
                    </div>
                </div>
                <div class="card mb-0 border-primary px-3 py-3 flex flex-column gap-3">
                    <div class="flex justify-content-between align-items-center">
                        <span class="font-semibold">Trong ca</span>
                        <span class="text-primary font-semibold">Tiền mặt: {{ formatPrice(Math.trunc(totalNghiepVu)) }}</span>
                    </div>
                    <div class="grid">
                        <div class="col-12 flex justify-content-between gap-2">
                            <div class="card bg-primary-50 border-primary w-full flex flex-column gap-2 mb-0 p-3 cursor-pointer" @click="openDetail(infoShift.id, 13)">
                                <div class="flex gap-2 mb-2"><strong>Bán hàng </strong><span></span></div>
                                <div v-for="(i, idx) in openShiftInvoice?.payments.filter((el) => el.method)" :key="idx">
                                    <div class="flex align-items-center justify-content-between text-sm">
                                        <span>{{ i.method }}</span>
                                        <span>{{ formatPrice(i.amount) }}</span>
                                    </div>
                                    <hr />
                                </div>
                                <div class="flex align-items-center justify-content-between text-sm">
                                    <span>Tổng</span>
                                    <span>{{
                                        openShiftInvoice?.payments
                                            ? formatPrice(
                                                  openShiftInvoice?.payments.reduce((total, el) => {
                                                      return total + el.amount;
                                                  }, 0)
                                              )
                                            : 0
                                    }}</span>
                                </div>
                            </div>

                            <div class="card bg-primary-50 border-primary w-full flex flex-column gap-2 mb-0 p-3 cursor-pointer" @click="openDetail(infoShift.id, 18)">
                                <div class="flex gap-2 mb-2"><strong>Mua hàng </strong><span></span></div>
                                <div v-for="(i, idx) in PurchaseInvoice?.payments" :key="idx">
                                    <div class="flex align-items-center justify-content-between text-sm">
                                        <span>{{ i.method }}</span>
                                        <span>{{ formatPrice(i.amount) }}</span>
                                    </div>
                                    <hr />
                                </div>
                                <div class="flex align-items-center justify-content-between text-sm">
                                    <span>Tổng</span>
                                    <span>{{
                                        PurchaseInvoice?.payments
                                            ? formatPrice(
                                                  PurchaseInvoice?.payments.reduce((total, el) => {
                                                      return total + el.amount;
                                                  }, 0)
                                              )
                                            : 0
                                    }}</span>
                                </div>
                            </div>

                            <div class="card bg-primary-50 border-primary w-full flex flex-column gap-2 mb-0 p-3 cursor-pointer" @click="openDetail(infoShift.id, 19)">
                                <div class="flex gap-2 mb-2"><strong>Đổi hàng</strong><span></span></div>
                                <div v-for="(i, idx) in doiHang?.payments" :key="idx">
                                    <div class="flex align-items-center justify-content-between text-sm">
                                        <span>{{ i.method }}</span>
                                        <span>{{ formatPrice(i.amount) }}</span>
                                    </div>
                                    <hr />
                                </div>
                                <div class="flex align-items-center justify-content-between text-sm">
                                    <span>Tổng</span>
                                    <span>{{
                                        doiHang?.payments
                                            ? formatPrice(
                                                  doiHang?.payments.reduce((total, el) => {
                                                      return total + el.amount;
                                                  }, 0)
                                              )
                                            : 0
                                    }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 flex justify-content-between py-0 gap-2">
                            <div class="card bg-primary-50 border-primary w-full flex flex-column gap-2 mb-0 p-3 cursor-pointer" @click="openDetail(infoShift.id, null, 'PT')">
                                <div class="flex gap-2 mb-2"><strong>Phiếu thu</strong><span></span></div>
                                <div v-for="(i, idx) in phieuThu?.payments" :key="idx">
                                    <div class="flex align-items-center justify-content-between text-sm">
                                        <span>{{ i.method }}</span>
                                        <span>{{ formatPrice(i.amount) }}</span>
                                    </div>
                                    <hr />
                                </div>
                                <div class="flex align-items-center justify-content-between text-sm">
                                    <span>Tổng</span>
                                    <span>{{
                                        phieuThu?.payments
                                            ? formatPrice(
                                                  phieuThu?.payments.reduce((total, el) => {
                                                      return total + el.amount;
                                                  }, 0)
                                              )
                                            : 0
                                    }}</span>
                                </div>
                            </div>

                            <div class="card bg-primary-50 border-primary w-full flex flex-column gap-2 mb-0 p-3 cursor-pointer" @click="openDetail(infoShift.id, null, 'PC')">
                                <div class="flex gap-2 mb-2"><strong>Phiếu chi</strong><span></span></div>
                                <div v-for="(i, idx) in phieuChi?.payments" :key="idx">
                                    <div class="flex align-items-center justify-content-between text-sm">
                                        <span>{{ i.method }}</span>
                                        <span>{{ formatPrice(i.amount) }}</span>
                                    </div>
                                    <hr />
                                </div>
                                <div class="flex align-items-center justify-content-between text-sm">
                                    <span>Tổng</span>
                                    <span>{{
                                        phieuChi?.payments
                                            ? formatPrice(
                                                  phieuChi?.payments.reduce((total, el) => {
                                                      return total + el.amount;
                                                  }, 0)
                                              )
                                            : 0
                                    }}</span>
                                </div>
                            </div>

                            <div class="card bg-primary-50 border-primary w-full flex flex-column gap-2 mb-0 p-3 cursor-pointer" @click="openDetail(infoShift.id, 26)">
                                <div class="flex gap-2 mb-2"><strong>Đặt hàng</strong><span></span></div>
                                <div v-for="(i, idx) in datHang?.payments" :key="idx">
                                    <div class="flex align-items-center justify-content-between text-sm">
                                        <span>{{ i.method }}</span>
                                        <span>{{ formatPrice(i.amount) }}</span>
                                    </div>
                                    <hr />
                                </div>
                                <div class="flex align-items-center justify-content-between text-sm">
                                    <span>Tổng</span>
                                    <span>{{
                                        datHang?.payments
                                            ? formatPrice(
                                                  datHang?.payments.reduce((total, el) => {
                                                      return total + el.amount;
                                                  }, 0)
                                              )
                                            : 0
                                    }}</span>
                                </div>
                            </div>

                            <div class="card bg-primary-50 border-primary w-full flex flex-column gap-2 mb-0 p-3 cursor-pointer" @click="openDetail(infoShift.id, 88)">
                                <div class="flex gap-2 mb-2"><strong>Bảo hành</strong><span></span></div>
                                <div v-for="(i, idx) in baoHanh?.payments" :key="idx">
                                    <div class="flex align-items-center justify-content-between text-sm">
                                        <span>{{ i.method }}</span>
                                        <span>{{ formatPrice(i.amount) }}</span>
                                    </div>
                                    <hr />
                                </div>
                                <div class="flex align-items-center justify-content-between text-sm">
                                    <span>Tổng</span>
                                    <span>{{
                                        baoHanh?.payments
                                            ? formatPrice(
                                                  baoHanh?.payments.reduce((total, el) => {
                                                      return total + el.amount;
                                                  }, 0)
                                              )
                                            : 0
                                    }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card mb-0 flex flex-column gap-2 border-primary px-3 py-3">
                    <div class="flex justify-content-between align-items-center">
                        <span class="font-semibold">Cuối ca</span>
                        <span class="text-primary font-semibold">Tiền mặt: {{ infoShift.startAmount ? formatPrice(infoShift.startAmount + totalNghiepVu) : 0 }}</span>
                    </div>
                    <div class="flex justify-content-between gap-2">
                        <div class="flex flex-column gap-2 w-full">
                            <label for="">Tiền mặt bàn giao thực tế <sup class="text-red-500">*</sup></label>
                            <InputNumber v-model="infoShift.actualEndShiftAmount"> </InputNumber>
                        </div>
                        <div class="flex flex-column gap-2 w-full">
                            <label for="">Số tiền chênh lệch <sup class="text-red-500">&nbsp;</sup></label>
                            <InputNumber :modelValue="infoShift.actualEndShiftAmount ? infoShift.actualEndShiftAmount - (infoShift.startAmount + totalNghiepVu) : 0"> </InputNumber>
                        </div>
                        <div class="flex flex-column gap-2 w-full">
                            <label for="">Ghi chú <sup class="text-red-500">&nbsp;</sup></label>
                            <InputText v-model="infoShift.endShiftNote"></InputText>
                        </div>
                    </div>
                </div>
                <div class="card mb-0 flex flex-column gap-2 border-primary px-3 py-3">
                    <span class="font-semibold">Đối chiếu thực tế theo các PTTT khác</span>
                    <table class="recon-table w-full">
                        <thead>
                            <tr>
                                <th>Phương thức thanh toán</th>
                                <th class="text-right">Theo hệ thống<br /><small class="font-normal">Thuần=Thu-chi</small></th>
                                <th class="text-right">Theo thực tế<br /><small class="font-normal">Thuần=Thu-chi</small></th>
                                <th class="text-right">Chênh lệch<br /><small class="font-normal">Thực tế - HT</small></th>
                                <th>Giải trình CL</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="r in reconciliations" :key="reconKey(r)">
                                <td>{{ formatMethodLabel(r) }}</td>
                                <td class="text-right">{{ formatPrice(r.systemAmount) }}</td>
                                <td class="recon-input">
                                    <InputNumber v-model="r.actualAmount" :inputClass="'text-right'" class="w-full" />
                                </td>
                                <td class="text-right" :class="{ 'text-red-500': (r.actualAmount || 0) - r.systemAmount !== 0 }">
                                    {{ formatPrice((r.actualAmount || 0) - r.systemAmount) }}
                                </td>
                                <td class="recon-input">
                                    <InputText v-model="r.note" class="w-full" placeholder="Nhập text" />
                                </td>
                            </tr>
                            <tr v-if="!reconciliations.length">
                                <td colspan="5" class="text-center text-600">Không có giao dịch theo PTTT khác</td>
                            </tr>
                        </tbody>
                        <tfoot v-if="reconciliations.length">
                            <tr class="font-semibold">
                                <td>Tổng hợp</td>
                                <td class="text-right">{{ formatPrice(reconTotals.system) }}</td>
                                <td class="text-right">{{ formatPrice(reconTotals.actual) }}</td>
                                <td class="text-right" :class="{ 'text-red-500': reconTotals.diff !== 0 }">{{ formatPrice(reconTotals.diff) }}</td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
            <template #footer>
                <div class="flex justify-content-end w-full gap-2">
                    <Button type="button" label="Đóng ca" severity="secondary" :loading="checkingPending" @click="openConfirmCloseShift()"></Button>
                    <!-- <Button type="button" severity="primary" label="Đóng ca và in biên bản kết ca"></Button> -->
                </div>
            </template>
        </Dialog>

        <Dialog v-model:visible="closeShiftModal" modal header="Xác nhận" position="top" :draggable="false" :style="{ width: '25rem' }">
            <div class="text-center p-2">Xác nhận đóng ca ?</div>
            <template #footer>
                <div class="flex justify-content-end gap-2">
                    <Button type="button" label="Hủy" severity="secondary" @click="closeShiftModal = false"></Button>
                    <Button type="button" label="Xác nhận" severity="danger" @click="confirmCloseShift('C')"></Button>
                </div>
            </template>
        </Dialog>
        <Dialog v-model:visible="exportReportModal" modal header="Đóng ca thành công" position="top" :draggable="false" :closable="false" :style="{ width: '30rem' }">
            <div class="flex flex-column gap-3 p-2">
                <p class="m-0 text-center">Ca đã được đóng. Bạn có thể xuất báo cáo cho ca vừa đóng:</p>
                <div class="flex flex-column gap-2">
                    <Button @click="exportKetCaReport()" label="Báo cáo 1 (Kết ca)" icon="pi pi-file-pdf" severity="danger" :loading="isLoadingKetCa"></Button>
                    <Button @click="exportDetailReport()" label="Báo cáo 2 (Chi tiết)" icon="pi pi-file-pdf" severity="danger" :loading="isLoadingDetailReport"></Button>
                </div>
            </div>
            <template #footer>
                <div class="flex justify-content-end w-full">
                    <Button type="button" label="Đóng" severity="secondary" @click="finishCloseShift()"></Button>
                </div>
            </template>
        </Dialog>
        <Dialog v-model:visible="pendingTransactionsModal" modal header="Không thể đóng ca" position="top" :draggable="false" :style="{ width: '40rem' }">
            <div class="p-2">
                <p class="m-0 mb-2 text-red-500 font-semibold">Vẫn còn giao dịch chưa hoàn tất trong ca. Vui lòng xử lý trước khi đóng ca:</p>
                <p v-if="pendingTransactions.some((p) => p.objType === 67)" class="m-0 mb-2">
                    Phiếu điều chuyển phải hoàn tất trong ngày: quầy nhận cần vào màn <b>Điều chuyển kho</b> để <b>đồng ý</b> hoặc <b>từ chối</b> phiếu. Khi chưa xử lý, cả quầy chuyển và quầy nhận đều không đóng được ca.
                </p>
                <DataTable :value="pendingTransactions" size="small" scrollable scrollHeight="300px">
                    <Column header="#">
                        <template #body="sp">{{ sp.index + 1 }}</template>
                    </Column>
                    <Column field="docCode" header="Mã phiếu"></Column>
                    <Column field="objType" header="Loại">
                        <template #body="sp">{{ formatObjType(sp.data.objType) }}</template>
                    </Column>
                    <Column field="statusLabel" header="Trạng thái"></Column>
                </DataTable>
            </div>
            <template #footer>
                <div class="flex justify-content-end gap-2">
                    <Button type="button" label="Đã hiểu" severity="secondary" @click="pendingTransactionsModal = false"></Button>
                </div>
            </template>
        </Dialog>
        <Dialog v-model:visible="isVisibleDetail" modal :header="`Chi tiết ${formatObjType(filter.docType || filter.paymentType)}`" :draggable="false" :style="{ width: '70%' }">
            <DataTable
                :value="shiftsHistory || []"
                :rows="paginator.PageSize"
                :page="paginator.Page"
                :totalRecords="paginator.total"
                lazy
                paginator
                showGridlines
                size="medium"
                @page="onDetailPageChange($event)"
                scrollable
                scrollHeight="400px"
                tableStyle="min-width: 50rem"
            >
                <template #empty>
                    <div class="text-center p-2">Dữ liệu trống</div>
                </template>
                <Column header="#">
                    <template #body="sp">
                        {{ sp.index + 1 }}
                    </template>
                </Column>
                <Column field="docCode" header="Chứng từ gốc">
                    <template #body="sp">
                        {{ sp.data?.docCode ? sp.data.docCode : '--' }}
                        <!-- <Button @click="openDocDialog(sp.data.odoc)" text :label="sp.data.docCode"></Button> -->
                    </template>
                </Column>
                <Column header="Trạng thái">
                    <template #body="sp">
                        {{ sp.data?.odoc ? renderStatus(sp.data.odoc) : '--' }}
                    </template>
                </Column>

                <Column field="paymentCode" header="Số PT/PC"></Column>
                <Column header="Thời gian">
                    <template #body="sp">
                        {{ sp.data.createdDate ? format(sp.data.createdDate, 'HH:mm dd/MM/yyyy') : '--' }}
                    </template>
                </Column>
                <Column field="partnerType" header="Đối tượng">
                    <template #body="sp">
                        {{ sp.data?.partnerType === 'C' ? `Khách hàng` : sp.data?.partnerType === 'V' ? `Nhà cung cấp` : `Nội bộ` }}
                    </template>
                </Column>
                <Column field="paymentLine" header="Hình thức thanh toán">
                    <template #body="sp">
                        <div>
                            {{ sp.data?.paymentLine?.map((el) => el.paymentMethodName).join(', ') }}
                        </div>
                    </template>
                </Column>

                <Column header="Giá trị">
                    <template #body="sp">
                        <div v-if="!sp.data.docType">
                            {{
                                sp.data?.paymentLine?.length > 0
                                    ? formatPrice(
                                          sp.data?.paymentLine?.reduce((total, el) => {
                                              return total + el.amount;
                                          }, 0)
                                      )
                                    : 0
                            }}
                        </div>
                        <div v-else>
                            {{ getTotalDetail(sp.data) }}
                        </div>
                    </template>
                </Column>
                <Column field="partnerName" header="Khách hàng"> </Column>
                <Column field="counter" header="Quầy">
                    <template #body="sp">
                        <div>
                            {{ sp.data?.counter?.name }}
                        </div>
                    </template>
                </Column>
            </DataTable>
        </Dialog>
    </div>
</template>
<script setup>
import { computed, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import API from '../../../api/api-main';
import { format } from 'date-fns';
import { getCurrentInstance } from 'vue';
import { useToast } from 'primevue/usetoast';
import router from '../../../router';
import { renderStatus, isPendingDoc } from '../../../helper/renderStatus';
const { proxy } = getCurrentInstance();
const toast = useToast();
const store = useStore();
const UserOnShift = store.state.auth.user.appUser;
const infoShift = ref({
    id: 0,
    shiftStatus: '',
    endShiftNote: '',
    endShiftAmount: 0,
    actualEndShiftAmount: 0
});
const buyingSelling = ref([]);
const openShiftInvoice = ref({});
const PurchaseInvoice = ref({});
const phieuThu = ref({});
const phieuChi = ref({});
const doiHang = ref({});
const datHang = ref({});
const baoHanh = ref({});
const reconciliations = ref([]);
const submited = ref(false);
const CloseShiftModal = ref(false);
const payload = ref({
    startAmount: 0,
    startShiftNote: ''
});

onMounted(async () => {
    await getShift();
    if (!infoShift.value.id) {
        OpenShiftModal.value = true;
    }
    payload.value.userName = UserOnShift.fullName;
    payload.value.userPhoneNumber = UserOnShift.phone;
});
const emits = defineEmits(['shifts']);
const OpenShiftModal = ref(false);
const closeShiftModal = ref(false);
// Popup xuất báo cáo hiện ngay sau khi đóng ca (bắt buộc xem trước khi rời màn - phương án A).
const exportReportModal = ref(false);
const closedShiftId = ref(null);
const isLoadingKetCa = ref(false);
const isLoadingDetailReport = ref(false);
const banHang = computed(() => {
    return openShiftInvoice.value
        ? openShiftInvoice.value?.payments
              .filter((el) => el.method === 'Tiền mặt')
              .reduce((total, el) => {
                  return total + el.amount;
              }, 0)
        : 0;
});
const muaHang = computed(() => {
    return PurchaseInvoice.value
        ? PurchaseInvoice.value?.payments
              .filter((el) => el.method === 'Tiền mặt')
              .reduce((total, el) => {
                  return total + el.amount;
              }, 0)
        : 0;
});
const phieuThuComputed = computed(() => {
    return phieuThu.value
        ? phieuThu.value?.payments
              .filter((el) => el.method === 'Tiền mặt')
              .reduce((total, el) => {
                  return total + el.amount;
              }, 0)
        : 0;
});
const phieuChiComputed = computed(() => {
    return phieuChi.value
        ? phieuChi.value?.payments
              .filter((el) => el.method === 'Tiền mặt')
              .reduce((total, el) => {
                  return total + el.amount;
              }, 0)
        : 0;
});
const doiHangComputed = computed(() => {
    return doiHang.value
        ? doiHang.value?.payments
              .filter((el) => el.method === 'Tiền mặt')
              .reduce((total, el) => {
                  return total + el.amount;
              }, 0)
        : 0;
});
const datHangComputed = computed(() => {
    return datHang.value
        ? datHang.value?.payments
              .filter((el) => el.method === 'Tiền mặt')
              .reduce((total, el) => {
                  return total + el.amount;
              }, 0)
        : 0;
});
const baoHanhComputed = computed(() => {
    return baoHanh.value
        ? baoHanh.value?.payments
              .filter((el) => el.method === 'Tiền mặt')
              .reduce((total, el) => {
                  return total + el.amount;
              }, 0)
        : 0;
});
const totalNghiepVu = computed(() => {
    return banHang.value + phieuThuComputed.value - muaHang.value - phieuChiComputed.value + doiHangComputed.value + datHangComputed.value + baoHanhComputed.value;
});

// Nguồn dữ liệu đối soát: sign = +1 (tiền vào), -1 (tiền ra) — đồng nhất với cách tính totalNghiepVu.
const reconSources = () => [
    { data: openShiftInvoice.value, sign: 1 }, // Bán hàng
    { data: PurchaseInvoice.value, sign: -1 }, // Mua hàng
    { data: doiHang.value, sign: 1 }, // Đổi hàng
    { data: datHang.value, sign: 1 }, // Đặt hàng
    { data: baoHanh.value, sign: 1 }, // Bảo hành
    { data: phieuThu.value, sign: 1 }, // Phiếu thu
    { data: phieuChi.value, sign: -1 } // Phiếu chi
];

// STK ngân hàng của 1 dòng thanh toán (chấp nhận nhiều cách BE đặt tên field).
const getBankCardCode = (p) => p?.bankCardCode || p?.bankAccount || p?.accountNumber || '';
// Khóa gom nhóm: mỗi quầy có nhiều STK → tách riêng từng (PTTT + STK) để đối chiếu.
const reconKey = (r) => (getBankCardCode(r) ? `${r.method}|${getBankCardCode(r)}` : r.method);

// Tổng hợp số tiền theo từng PTTT + STK (trừ Tiền mặt — đã đối soát riêng ở phần Cuối ca).
const buildReconciliations = () => {
    const map = {};
    reconSources().forEach(({ data, sign }) => {
        (data?.payments || []).forEach((p) => {
            if (!p.method || p.method === 'Tiền mặt') return;
            const key = reconKey(p);
            if (!map[key]) {
                map[key] = { method: p.method, bankName: p.bankName || '', bankCardCode: getBankCardCode(p), amount: 0 };
            }
            map[key].amount += sign * (p.amount || 0);
        });
    });
    // Giữ lại số đã nhập (từ lần dựng trước hoặc dữ liệu ca đã lưu) khi dựng lại bảng.
    const saved = {};
    (infoShift.value?.paymentReconciliations || []).forEach((r) => (saved[reconKey(r)] = r));
    reconciliations.value.forEach((r) => {
        const k = reconKey(r);
        if (!(k in saved)) saved[k] = r;
    });
    reconciliations.value = Object.keys(map).map((key) => {
        const m = map[key];
        return {
            method: m.method,
            bankName: m.bankName,
            bankCardCode: m.bankCardCode,
            systemAmount: Math.trunc(m.amount),
            actualAmount: saved[key]?.actualAmount ?? null,
            note: saved[key]?.note ?? ''
        };
    });
};

const reconTotals = computed(() => {
    return reconciliations.value.reduce(
        (acc, r) => {
            const actual = r.actualAmount || 0;
            acc.system += r.systemAmount || 0;
            acc.actual += actual;
            acc.diff += actual - (r.systemAmount || 0);
            return acc;
        },
        { system: 0, actual: 0, diff: 0 }
    );
});
const getShift = async () => {
    try {
        const res = await API.get(`Shift/GetShiftByUser`);
        // TODO(tạm): kiểm tra field STK/ngân hàng trong payments[] sau khi backend update — xóa sau khi xác nhận.
        console.log('GetShiftByUser payments[]:', JSON.stringify(res.data?.buyingSelling?.flatMap((b) => b.payments || []), null, 2));
        if (res.data.shift) {
            infoShift.value = res.data.shift;
            openShiftInvoice.value = res.data ? res.data.buyingSelling?.find((el) => el.objType === 13) : {};
            PurchaseInvoice.value = res.data ? res.data.buyingSelling?.find((el) => el.objType === 18) : {};
            doiHang.value = res.data ? res.data.buyingSelling?.find((el) => el.objType === 19) : {};
            datHang.value = res.data ? res.data.buyingSelling?.find((el) => el.objType === 26) : {};
            baoHanh.value = res.data ? res.data.buyingSelling?.find((el) => el.objType === 88) : {};

            phieuChi.value = res.data.payment.find((el) => el.paymentType === 'PC');
            phieuThu.value = res.data.payment.find((el) => el.paymentType === 'PT');
            buyingSelling.value = res.data.buyingSelling;
            buildReconciliations();
        }
        emits('shifts', infoShift.value ? infoShift.value : []);
    } catch (error) {
        console.log(error);
    }
};

const confirmCloseShift = async (status) => {
    // Lưu id ca đang đóng trước khi infoShift bị ghi đè bởi res.data.newShift.
    const closingShiftId = infoShift.value.id;
    let data = {
        ...infoShift.value,
        shiftStatus: status,
        paymentReconciliations: reconciliations.value.map((r) => ({
            method: r.method,
            bankName: r.bankName || '',
            bankCardCode: r.bankCardCode || '',
            systemAmount: r.systemAmount,
            actualAmount: r.actualAmount || 0,
            diffAmount: (r.actualAmount || 0) - r.systemAmount,
            note: r.note || ''
        }))
    };
    submited.value = true;
    // if (!ValidateData(data)) return;
    try {
        const res = await API.update(`Shift/UpdateShift`, data);
        if (res.data) {
            infoShift.value = res.data.newShift;
            getShift();
            OpenShiftModal.value = false;
            // Đóng các dialog đóng ca, mở popup xuất báo cáo cho ca vừa đóng.
            // Chưa redirect - chỉ chuyển về màn mở ca khi người dùng đóng popup (finishCloseShift).
            closeShiftModal.value = false;
            CloseShiftModal.value = false;
            closedShiftId.value = closingShiftId;
            exportReportModal.value = true;
        }
    } catch (error) {
        proxy.$notify('E', error.response.data.errors, toast);
    }
};

// Xuất báo cáo cho ca vừa đóng (dùng chung logic tải file blob như màn ShiftsReport).
const downloadShiftReport = async (endpoint, defaultFileName, loadingRef) => {
    const shiftId = closedShiftId.value;
    if (!shiftId) {
        proxy.$notify('W', 'Không xác định được ca cần xuất báo cáo', toast);
        return;
    }
    loadingRef.value = true;
    try {
        const res = await API.get(`Shift/${shiftId}/${endpoint}`, { responseType: 'blob' });

        // Lấy tên file từ header Content-Disposition nếu có
        const cd = res.headers['content-disposition'] || '';
        const match = /filename\*?=(?:UTF-8'')?["']?([^"';]+)/i.exec(cd);
        const fileName = match ? decodeURIComponent(match[1]) : defaultFileName;

        const url = URL.createObjectURL(res.data);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);

        proxy.$notify('S', 'Xuất file thành công', toast);
    } catch (error) {
        console.log(error);
        proxy.$notify('E', 'Đã xảy ra lỗi khi xuất báo cáo', toast);
    } finally {
        loadingRef.value = false;
    }
};

// Màn kết ca luôn xuất PDF (?format=pdf). Tên file lấy theo Content-Disposition của backend,
// chuỗi dưới đây chỉ là fallback khi header thiếu.
const exportKetCaReport = () => {
    downloadShiftReport('ExportKetCaReport?format=pdf', `BaoCao1_KetCa_Ca${closedShiftId.value}.pdf`, isLoadingKetCa);
};

const exportDetailReport = () => {
    downloadShiftReport('ExportDetailReport?format=pdf', `BaoCao2_Ca${closedShiftId.value}.pdf`, isLoadingDetailReport);
};

// Đóng popup xuất báo cáo → chuyển về màn mở ca (chỉ redirect ở bước này - phương án A).
const finishCloseShift = () => {
    exportReportModal.value = false;
    closedShiftId.value = null;
    router.push({ name: 'open-shifts' });
};
const ValidateData = (data) => {
    if (!data.actualEndShiftAmount) {
        proxy.$notify('E', `Vui lòng nhập tiền mặt bàn giao thực tế!`, toast);
        return false;
    }
    return true;
};
const CloseShiftDialog = () => {
    getShift();
    submited.value = false;
    CloseShiftModal.value = true;
};
const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US').format(price);
};

// Nhãn 1 dòng đối chiếu: gộp PTTT + tên NH + STK để đối chiếu riêng từng tài khoản.
// Các giao dịch không phải chuyển khoản (không có STK) chỉ hiện tên PTTT.
const formatMethodLabel = (r) => {
    const parts = [r.method, r.bankName, r.bankCardCode].filter((x) => x && String(x).trim());
    return parts.join(' - ');
};

const convertPaymentType = (type) => {
    switch (type) {
        case 'cash':
            return 'Tiền mặt';
        case 'Cash':
            return 'Tiền mặt';
        case 'BankWire':
            return 'Chuyển khoản';
    }
};
const checkingPending = ref(false);
const pendingTransactionsModal = ref(false);
const pendingTransactions = ref([]);

const fetchPendingByDocType = async (shiftId, docType) => {
    const today = format(new Date(), 'yyyy/MM/dd');
    const url = `Shift/${shiftId}?Page=1&PageSize=10000&Filter=(docType=${docType}),(createdDate>=${today} 00:00),(createdDate<=${today} 23:59:59.999)`;
    try {
        const res = await API.get(url);
        const list = res?.data?.payment || [];
        // 1 hóa đơn có thể có nhiều dòng thanh toán (nhiều PTTT / nhiều lần thu)
        // → cùng 1 odoc trả về nhiều bản ghi. Gộp theo document để không bị trùng.
        const seen = new Set();
        const result = [];
        list.filter((p) => isPendingDoc(p.odoc)).forEach((p) => {
            const key = p.odoc?.id ?? p.odoc?.docCode ?? p.docCode;
            if (key != null && seen.has(key)) return;
            if (key != null) seen.add(key);
            result.push({
                docCode: p.odoc?.docCode || p.docCode || '--',
                objType: docType,
                statusLabel: p.odoc ? renderStatus(p.odoc) : '--'
            });
        });
        return result;
    } catch (e) {
        console.error('Lỗi kiểm tra giao dịch ca:', e);
        return [];
    }
};

// Phiếu điều chuyển (TF/TFJ) trong tháng còn chờ quầy nhận đồng ý/từ chối: cả quầy chuyển lẫn quầy nhận đều không đóng được ca.
const fetchPendingTransfers = async () => {
    try {
        const res = await API.get('Shift/PendingTransfers');
        return res?.data?.items || [];
    } catch (e) {
        console.error('Lỗi kiểm tra phiếu điều chuyển:', e);
        return [];
    }
};

// Chặn đóng ca khi tiền thực tế lệch so với hệ thống (tiền mặt + các PTTT khác).
const validateNoDiscrepancy = () => {
    if (infoShift.value.actualEndShiftAmount == null) {
        proxy.$notify('E', 'Vui lòng nhập tiền mặt bàn giao thực tế!', toast);
        return false;
    }
    const cashSystem = Math.trunc(infoShift.value.startAmount + totalNghiepVu.value);
    const cashDiff = infoShift.value.actualEndShiftAmount - cashSystem;
    if (cashDiff !== 0) {
        proxy.$notify('E', `Tiền mặt thực tế đang chênh lệch ${formatPrice(cashDiff)} so với hệ thống. Vui lòng kiểm tra lại trước khi đóng ca!`, toast);
        return false;
    }
    const reconDiffs = reconciliations.value.filter((r) => (r.actualAmount || 0) - (r.systemAmount || 0) !== 0);
    if (reconDiffs.length) {
        const labels = reconDiffs.map((r) => formatMethodLabel(r)).join(', ');
        proxy.$notify('E', `Còn chênh lệch giữa thực tế và hệ thống ở: ${labels}. Vui lòng kiểm tra lại trước khi đóng ca!`, toast);
        return false;
    }
    return true;
};

const openConfirmCloseShift = async () => {
    if (!infoShift.value?.id) return;
    if (!validateNoDiscrepancy()) return;
    checkingPending.value = true;
    try {
        // Không kiểm tra giao dịch chưa xử lý của Bảo hành / Dịch vụ (objType 88) khi đóng ca.
        // Đổi trả hàng (19) phải về "Đã trả vàng" mới được đóng ca.
        // Mua hàng (18) chỉ chặn khi dừng ở "Hủy lần 1" — chưa trả vàng, tồn kho chưa hoàn.
        const pendingLists = await Promise.all([...[13, 18, 19].map((docType) => fetchPendingByDocType(infoShift.value.id, docType)), fetchPendingTransfers()]);
        const pending = pendingLists.flat();
        if (pending.length) {
            pendingTransactions.value = pending;
            pendingTransactionsModal.value = true;
            return;
        }
        closeShiftModal.value = true;
    } finally {
        checkingPending.value = false;
    }
};

const paginator = ref({
    Page: 0,
    PageSize: 10,
    total: 0
});
const filter = reactive({
    docType: null,
    id: null,
    paymentType: null
});

const isVisibleDetail = ref(false);
const shiftsHistory = ref([]);
const openDetail = async (id, type, paymentType = null) => {
    filter.id = id;
    filter.docType = type;
    filter.paymentType = paymentType;
    await getDetail();
    isVisibleDetail.value = true;
};

const getDetail = async () => {
    let url = `Shift/${filter.id}?Page=${paginator.value.Page + 1}&PageSize=${paginator.value.PageSize}&Filter=docType=${filter.docType}${filter.paymentType ? `,paymentType=${filter.paymentType}` : ''}`;
    const res = await API.get(url);
    shiftsHistory.value = res.data.payment;
    paginator.value.total = res.data.total;
};
const onDetailPageChange = (e) => {
    paginator.value.Page = e.page;
    getDetail();
};
const formatObjType = (stt) => {
    switch (stt) {
        case 13:
            return 'bán hàng';
        case 18:
            return 'mua hàng';
        case 19:
            return 'đổi trả hàng';
        case 'PT':
            return 'phiếu thu';
        case 'PC':
            return 'phiếu chi';
        case 26:
            return 'đặt hàng';
        case 88:
            return 'bảo hành';
        case 67:
            return 'điều chuyển';
        default:
            return '';
    }
};

const getTotalDetail = (data) => {
    if (data.paymentLine.length > 0) {
        const total = data.paymentLine.reduce((total, el) => {
            return total + el.amount;
        }, 0);
        return formatPrice(total);
    }
    const total = data.paymentAmount || 0;
    return formatPrice(total);
};
</script>
<style scoped>
.recon-table {
    border-collapse: collapse;
}
.recon-table th,
.recon-table td {
    border: 1px solid var(--surface-border);
    padding: 0.5rem 0.75rem;
    vertical-align: middle;
}
.recon-table thead th {
    background: var(--surface-100);
    text-align: left;
    font-weight: 600;
}
.recon-table tfoot td {
    background: var(--surface-50);
}
/* Cột người dùng tự nhập (nền vàng) */
.recon-table td.recon-input {
    background: #fff8e1;
    padding: 0.25rem;
}
.recon-table :deep(.p-inputnumber),
.recon-table :deep(.p-inputtext) {
    width: 100%;
}
</style>
